<template lang="pug">
#app
  Header(ref='header')
  #tLogin
    .first_screen
      //- 轮播图
      //- div.banner-container
      //-   div.banner-wrapper(
      //-     :class='{animated: slideAnimated}' 
      //-     :style='{transform: "translateX(" + offset + "px)"}' 
      //-     @transitionend='handleSlideEnd')
      //-     div.banner(v-for='idx in "010"' :class="('b' + idx)")
      //-       img(:src='picUrl("bg" + (parseInt(idx) + 1) + ".png")')
      //-   div.banner-indicator
      //-     div(:class='{ active: indicate % 2 === 0}')
      //-     div(:class='{ active: indicate % 2 === 1}')
      //- 登录框
      img(src='/static/images/bg_test.png')
      Form(
        v-if='init',
        :toggleFindPwd='toggleFindPwd',
        @next='next',
        ist2s,
        @perfectInfo='perfectInfo'
      )
  Footer(ref='footer')
  FindPwd(
    ref='findPwd',
    :toggleFindPwd='toggleFindPwd',
    v-if='showFP',
    @login='$store.login'
  )
  Cover(@close='closeCover', v-if='currentCoverComponent')
    Activation(
      v-if='currentCoverComponent === "Activation"',
      @perfectInfo='perfectInfo',
      :numberId='numberId'
    )
    Perfect(
      v-if='currentCoverComponent === "Perfect"',
      :perfectData='perfectData',
      ref='perf'
    )
</template>

<script>
import { $cookie } from '@/util/Util'
import Header from './components/header'
import Footer from './components/footer'
import Form from './components/Form'
import Cover from './components/cover'
import Activation from './components/activation'
import Perfect from './components/perfect/app'
import { getCfg } from '@/api'

const FindPwd = () => import('./components/findPwd')

export default {
  name: 'Login',
  components: { Header, Footer, Form, FindPwd, Cover, Activation, Perfect },
  data() {
    return {
      offset: 0,
      slideAnimated: true,
      imgs: {
        s2: false,
        s3: false,
        s4: false,
        s5: false,
        s6: false,
        s7: false,
        s8: false
      },
      gallery: [
        {
          text1: '教师的贴心助手',
          text2: '让教师轻松教学',
          url: 'screen_teacher'
        },
        {
          text1: '学生的良师益友',
          text2: '让学生更懂自己',
          url: 'screen_student'
        },
        {
          text1: '家长的放心陪读',
          text2: '让家长轻松育儿',
          url: 'screen_parent'
        },
        {
          text1: '教研的得力助手',
          text2: '让教研更懂教育',
          url: 'screen_section'
        }
      ],
      showFP: false, // 显示忘记密码对话框
      indicate: 0,
      showCover: false,
      showPerfect: false,
      numberId: '',
      picUrl: window.ConfigNew.logoUrl,
      init: false,
      currentCoverComponent: '',
      perfectData: {}
      // isShowPage: false
    }
  },
  methods: {
    getUrlParam() {
      let urlP = {}
      if (location.search) {
        location.search
          .substring(1)
          .split('&')
          .forEach(item => {
            let _kv = item.split('=')
            urlP[_kv[0]] = _kv[1]
          })
      }
      return urlP
    },
    openCover(currentCoverComponent) {
      this.currentCoverComponent = currentCoverComponent
    },
    perfectInfo(perfectData) {
      this.perfectData = perfectData
      this.openCover('Perfect')
    },
    closeCover() {
      this.currentCoverComponent = ''
    },
    next(id) {
      // 1001完善个人信息
      this.numberId = id
      this.openCover('Activation')
    },
    handleSlideEnd(evt) {
      if (evt.propertyName === 'transform') {
        if (this.indicate === 2) {
          this.slideAnimated = false
          this.indicate = 0
          this.offset = 0
        }
        this.slide()
      }
    },
    slide() {
      setTimeout(() => {
        this.slideAnimated = true
        this.indicate += 1
        this.offset = 0 - document.body.clientWidth * this.indicate
      }, 2000)
    },
    scrollPosition(index) {
      let total = document.querySelectorAll('.d_scroll')[index].offsetTop
      let distance = document.documentElement.scrollTop || document.body.scrollTop
      const step = total / 50
      total > distance && smoothDown()

      function smoothDown() {
        if (distance < total) {
          distance += step
          window.scrollTo(0, distance)
          setTimeout(smoothDown, 10)
        } else {
          window.scrollTo(0, total - 90)
        }
      }
    },
    toggleFindPwd() {
      this.showFP = !this.showFP
    }
  },
  created() {
    // getRegInfo().then(res => {
    //   var data = res.data
    //   localStorage.setItem('cpUrl', data.cpUrl)
    //   localStorage.setItem('zyUrl', data.zyUrl)
    //   localStorage.setItem('mUrl', data.mobileUrl)
    //   this.init = true
    // })
    getCfg()
      .then(data => {
        $cookie.set('hasZy', data.only_zy) // 仅作业
        $cookie.set('hasCp', data.only_cp) // 仅测评
        $cookie.set('model', data.to_b) // 1:2B else:2C 配置
        localStorage.setItem('cpUrl', data.cpUrl)
        localStorage.setItem('zyUrl', data.zyUrl)
        localStorage.setItem('mUrl', data.mUrl)
        localStorage.setItem('accUrl', data.ywUrl)
        localStorage.setItem('resUrl', data.resource_url + '/')
        localStorage.setItem('gatewayUrl', data.gatewayUrl)
        localStorage.setItem('pcpUrl', data.pcpUrl)

        // 判断是否要进入排队页面
        // this.$queueUp().then(() => {
        //   this.isShowPage = true
        this.init = true
        // })
      })
      .catch(res => {
        console.info(res)
      })
  },
  mounted() {
    document.querySelectorAll('.login-header img')[0].src =
      '/static/images/logo_jiaoshiyanxun.png'
    const windowHeight = window.innerHeight
    const lazyObjs = {}
    const lazyElms = document.getElementsByClassName('lazy')
    Array.prototype.forEach.call(lazyElms, elm => {
      lazyObjs[elm.attributes.name.value] = Number(elm.getBoundingClientRect().top)
    })
    window.onscroll = evt => {
      const height = windowHeight + window.scrollY
      for (let key in lazyObjs) {
        if (lazyObjs[key] < height - 200) {
          this.imgs[key] = true
          delete lazyObjs[key]
        }
      }
    }

    this.slide()
  }
}
</script>

<style lang="less">
@import url('./app.less');
#tLogin .loginOperation .loginpanel .identityTab > li {
  width: 50%;
}
#tLogin #sidebar .app.sidebarSection {
  display: none;
}
.login-header.bg-white {
  background-color: white !important;
}
.login-header .linkArea {
  display: none !important;
}
.loginOperation > .qrCode {
  display: none !important;
}
#tLogin .loginOperation .other_operation {
  display: none !important;
}
.login-header img {
  margin-left: 120px;
}
.login-header > div {
  padding: 0 !important;
}

#tLogin .loginpanel {
  width: 470px;
}
#tLogin .loginOperation .loginpanel button {
  width: 310px;
  height: 44px;
}
#tLogin .loginOperation .loginpanel .identityTab {
  width: 310px;
  height: 105px;
}
#tLogin {
  flex: 1;
  margin-top: 90px;
  div.first_screen {
    position: relative;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #21bd7c;
    img {
      position: absolute;
      width: 100%;
      padding: 0 20px;
      bottom: 0;
    }
  }
  .loginOperation {
    width: 470px;
    height: 410px;
    position: relative;
    margin: 0;
    right: 0;
    top: 0;
  }
  .loginOperation .loginpanel {
    > div {
      width: 310px;
    }
    .submit {
      margin-top: 21px;
    }
    .form-input > div {
      background: #fff;
      width: 20px;
      margin-left: 20px;
    }
    .form-input > input {
      padding-left: 5px;
    }
  }
}
html,
body,
#app {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/login/tApp.vue